/** Renders an ISO timestamp as a local date, or an em dash when absent. */
export const fmtDate = (iso: string | null): string =>
  iso ? new Date(iso).toLocaleDateString() : '—';
